"use client";

export default function PromptText({
  prompt,
  setPrompt,
  handleSubmit,
  placeholder,
}: {
  prompt: string;
  setPrompt: (prompt: string) => void;
  handleSubmit: (query: string) => void;
  placeholder: string;
}) {
  const onChange = function (evt: React.ChangeEvent<HTMLTextAreaElement>) {
    setPrompt(evt.target.value);
  };

  const onKeyDown = function (evt: React.KeyboardEvent<HTMLTextAreaElement>) {
    if (evt.key === "Enter" && !evt.shiftKey) {
      evt.stopPropagation();
      evt.preventDefault();
      handleSubmit(prompt);
    }
  };

  return (
    <textarea
      className="w-full h-full flex-1 border-none outline-none focus:ring-0 focus:border-none bg-transparent resize-none h-[4.5rem] overflow-y-auto"
      placeholder={placeholder}
      onChange={onChange}
      onKeyDown={onKeyDown}
      value={prompt}
    />
  );
}
